import React, { useEffect } from 'react';
import Banner from '../components/Banner';
import MyText from '../components/MyText';
import { useTranslation } from 'react-i18next';
import { theme } from '../utils/theme';
import Box from '../components/Box';
import Trees from '../components/Trees';
import colline from '../assets/colline.png';
import Button from '../components/Button';
import Footer from '../components/Footer';
import { useNavigate } from 'react-router-dom';
import { useApi } from '../context/ApiContext';
import { useMediaQuery } from 'react-responsive';

function MainContent(){
    const {t} = useTranslation();
    const navigate = useNavigate();
    const { getToken } = useApi();
    
    useEffect(() => {
        getToken();
    }, [])
    return (
        <div style={{...styles.page, backgroundImage: `url(${colline})`}}>
            <div style={styles.container}>
                <div style={styles.titleContainer}>
                    <MyText family={"livvic"} size={"4rem"} weight={"Bold"} 
                        color={theme.secondary} style={styles.title}>
                            {t('home_title')}
                    </MyText>
                </div>
                <Box style={{marginLeft: 10, marginRight: 10}}>
                    <div style={styles.boxContent}>
                        <Trees/>
                        <div style={styles.textContent}>
                            <MyText size={'1.2rem'} style={styles.text}>{t('home_boxLine1')}</MyText>
                            <MyText size={'1.2rem'} style={styles.text}>{t('home_boxLine2')}</MyText>
                            <MyText size={'1.2rem'} style={styles.text}>{t('home_boxLine3')}</MyText>
                            <MyText size={'1.2rem'} style={styles.text}>{t('home_boxLine4')}</MyText>
                        </div>
                        <div style={styles.blankSpace}/>
                    </div>
                </Box>
                <div style={styles.buttonContainer}>
                    <Button onClick={()=>{ navigate("/Candidatura")}} style={styles.button}>
                        <MyText>{t('home_button')}</MyText>
                    </Button>
                    <div style={{height: '250px', width: '100%'}} className='bottomShadow'/>
                </div>
            </div>
        </div>
    );
}

export default function Home (){
    const isMobile = useMediaQuery({ query: '(min-width: 768px)' });
    return (
        <div>
            {isMobile && <Banner/>}
            {!isMobile && <div style={{height: 20}}/>}
            <MainContent/>
            <Footer/>
        </div>
    );
};

const styles = {
    page:{
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        justifyContent: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'bottom',
    },
    container: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        // maxWidth: '1200px',
        // paddingLeft: 16,
        // paddingRight: 16,
        gap: 48,
    },
    titleContainer: {
        display: 'flex',
        justifyContent: 'center',
        // paddingLeft: '8px',
        // paddingRight: '8px',
        // width: '95%',
    },
    title:{
        textTransform: 'uppercase',
        textAlign: 'center',
        fontSize: 'clamp(24px, 10vw, 4rem)'
    },
    boxContent:{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        gap: 8,
        padding:'32px 16px',
    },
    textContent:{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        gap: 16
    },
    text:{
        textAlign: 'center',
    },
    blankSpace:{
        width: '20%',
    },
    buttonContainer:{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        gap: 16,
    },
    button:{
        backgroundColor: "#FFFFFFC7",
        width: 'fit-content',
    }
}